// Dialog "Aggiungi Servizio" del dettaglio preventivo PV
import { Button } from '../ui/button';
import {
    Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from '../ui/dialog';

const CATEGORY_LABELS = {
    INSTALLAZIONE: 'Installazione',
    BUROCRAZIA: 'Burocrazia',
    PROGETTAZIONE: 'Progettazione',
    ASSISTENZA: 'Assistenza',
};

export const QuoteAddServiceDialog = ({ open, onOpenChange, selectedCategory, serviceCatalog, onAddService }) => {
    const filtered = serviceCatalog.filter(s => !selectedCategory || s.category === selectedCategory);
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-2xl max-h-[80vh] overflow-hidden flex flex-col">
                <DialogHeader>
                    <DialogTitle>
                        Aggiungi Servizio - {CATEGORY_LABELS[selectedCategory] || 'Servizi'}
                    </DialogTitle>
                    <DialogDescription>Seleziona i servizi da aggiungere al preventivo</DialogDescription>
                </DialogHeader>
                <div className="flex-1 overflow-y-auto py-4">
                    <div className="space-y-2">
                        {filtered.map(service => (
                            <div 
                                key={service.id}
                                className="flex items-center justify-between p-3 border rounded-lg hover:bg-zinc-50 cursor-pointer transition-colors"
                                onClick={() => {
                                    onAddService(service);
                                    onOpenChange(false);
                                }}
                            >
                                <div>
                                    <p className="font-medium">{service.name}</p>
                                    <p className="text-sm text-zinc-500">{service.description}</p>
                                </div>
                                <div className="text-right">
                                    <p className="font-semibold">
                                        {service.default_price > 0 
                                            ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(service.default_price)
                                            : 'Incluso'
                                        }
                                    </p>
                                    <p className="text-xs text-zinc-400">per {service.default_unit}</p>
                                </div>
                            </div>
                        ))}
                        {filtered.length === 0 && (
                            <div className="text-center py-8 text-zinc-500">
                                Nessun servizio disponibile in questa categoria
                            </div>
                        )}
                    </div>
                </div>
                <DialogFooter>
                    <Button variant="outline" onClick={() => onOpenChange(false)}>
                        Chiudi
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
